import { FC } from "react";
import Layout from "../../layout/Layout";
import { Link } from "react-router-dom";

const TermAndConditionsNewUsed6MonthWarrany: FC<{}> = () => {
    return (
        <Layout>
            <div
                className="w-100 px-3 p_spaced"
                style={{ backgroundImage: "url(/assets/pages/contact/bg_contact.jpg)", backgroundSize: "contain" }}
            >
                <div className="container">
                    <div className="bg-white p-5">
                        <div className="side side_top mb-3">
                            <h2> Términos y Condiciones Campaña "Tu nuevo Usado en wcar con garantía de 6 meses"</h2>
                        </div>
                        <div className="side side_top mb-3">
                            <h3>
                                Aquí se despliegan los términos y condiciones generales de la campaña en referencia.
                            </h3>
                        </div>
                        <ul>
                            <li>
                                Organizador: Esta campaña es organizada por WCAR, con domicilio principal en la calle 98
                                a 69 b 35, Bogotá, Colombia.
                            </li>
                            <li>
                                Participantes: Pueden participar todas las personas naturales mayores de edad que
                                residan en la República de Colombia.
                            </li>
                            <li>Vigencia: La campaña estará vigente del 5 al 31 de diciembre de 2023.</li>
                        </ul>
                        <div className="side side_top mb-3">
                            <h3>Los beneficios enumerados a continuación con su respectiva explicación:</h3>
                        </div>

                        <div className="side  mb-3">
                            <h4>Garantía de 6 meses:</h4>
                        </div>
                        <p>
                            Condiciones del vehículo usado con la garantía de 6 meses: Los vehículos adquiridos bajo
                            esta campaña tendrán una garantía de 6 meses o 4.000km para determinados componentes, los
                            cuales están especificados en el documento de garantía disponible en
                            <strong>
                                <Link to={"wcar.co/garantia"}> wcar.co/garantía.</Link>{" "}
                            </strong>
                            La garantía entrará en vigencia desde la fecha exacta de entrega del vehículo.
                        </p>
                        <div className="side  mb-3">
                            <h4>Bono de regalo de $500,000:</h4>
                        </div>
                        <p>
                            Condiciones de Bono de $500.000 para ser redimido en gasolina, trámites o seguro: El cliente
                            comprador de vehículo podrá decidir entre las 3 opciones. Puede pedir un bono por $500,000
                            para usarse en gasolina ó $500,000 para usarlo en los gastos de trámite ó $500,000 para
                            pagar seguro todo riesgo. En ningún caso se podrán sumar estos 3 beneficios. La escogencia
                            del beneficio deberá quedar registrada por escrito en la orden de pedido. No canjeable por
                            efectivo u otros productos o servicios no relacionados aquí.{" "}
                        </p>
                        <div className="side  mb-3">
                            <h4>Cuotas diarias de $30,000: </h4>
                        </div>
                        <p>
                            El Plan de financiación aquí descrito es aplicable exclusivamente para vehículos ofertados
                            por WCAR. Las imágenes de equipamientos, accesorios y colores son de carácter ilustrativo y,
                            por ello, podrían no coincidir con las versiones y modelos disponibles en Colombia. Este
                            plan de financiación será proporcionado exclusivamente por entidades financieras aliadas a
                            Santander de Negocios Colombia S.A., y se sujetará a las siguientes condiciones: (i) Se
                            financiará hasta el 80% del valor total del vehículo, desglosado de la siguiente manera: 30%
                            a capital con intereses del 80% distribuido en 36 pagos mensuales y el 50% restante en un
                            solo pago al concluir el mes 36. Es importante mencionar que estas condiciones podrían
                            variar si se presentan incumplimientos en el cronograma de pagos. (ii) El solicitante deberá
                            realizar un pago inicial correspondiente al 20% del valor total del vehículo. (iii) La tasa
                            de interés, una vez establecida, será fija. Sin embargo, dicha tasa podría variar según el
                            perfil crediticio del solicitante. (iv) El periodo total de financiación no excederá los 36
                            meses. (v) Antes del primer desembolso, el solicitante está obligado a contratar las
                            siguientes pólizas de seguros: a) Seguro todo riesgo del vehículo financiado. b) Seguro de
                            vida a favor del solicitante. c) Seguro de protección financiera. El solicitante tiene total
                            libertad para seleccionar su proveedor de seguros, ya sea a través de Santander de Negocios
                            Colombia S.A., con una entidad financiera aliada o con cualquier otra entidad de su
                            elección. (vi) Si el solicitante decide financiar alguna o todas las pólizas mencionadas en
                            el numeral anterior a través de Santander de Negocios Colombia S.A. o una entidad aliada, el
                            valor de las cuotas mensuales podría sufrir variaciones. Cualquier cambio en las condiciones
                            será comunicado al solicitante con anticipación. El otorgamiento de este plan de
                            financiación depende del cumplimiento de las políticas crediticias de las entidades
                            financieras aliadas a Santander de Negocios Colombia S.A. y del perfil crediticio del
                            solicitante. La campaña es válida para radicaciones realizadas entre el 1 y el 20 de
                            diciembre de 2023, y para desembolsos efectuados antes del 25 de diciembre del mismo año.
                            Esta promoción no es acumulable con otros descuentos o campañas en vigor. Ni Santander de
                            Negocios Colombia S.A. WCAR asume compromisos de recompra respecto del vehículo adquirido
                            por el solicitante.
                        </p>
                        <div className="side  mb-3">
                            <h4>Bonos de descuento hasta por $5,000,0000</h4>
                        </div>
                        <p>
                            Aplica para unidades limitadas y que explícitamente tengan el bono registrado en la
                            publicación. Si es acumulable con otras promociones. No canjeable por efectivo ni otros
                            productos o servicios.{" "}
                        </p>
                        <div className="side  mb-3">
                            <h5>Aspectos generales:</h5>
                        </div>
                        <ul>
                            <li>Protección de Datos Personales:</li>
                            <li>
                                WCAR garantiza la protección de los datos personales según la normativa colombiana
                                vigente.
                            </li>
                        </ul>

                        <div className="side  mb-3">
                            <h5>Jurisdicción y Resolución de Conflictos:</h5>
                        </div>
                        <ul>
                            <li>
                                Cualquier desacuerdo o conflicto relacionado con esta campaña se resolverá bajo las
                                leyes de la República de Colombia.
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h5>Modificaciones:</h5>
                        </div>
                        <ul>
                            <li>
                                WCAR se reserva el derecho de modificar estos términos y condiciones, con efecto
                                inmediato tras su publicación en su página web.
                            </li>
                            <li>
                                Contacto: Para mayor información sobre la campaña, los participantes pueden contactar a
                                WCAR a través del correo electrónico contacto@wcar.co o llamando al teléfono 3244001212.{" "}
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h5>Nota Aclaratoria:</h5>
                        </div>
                        <ul>
                            <li>
                                Todos los demás términos y condiciones están detallados en el contrato de vinculación
                                cliente comprador.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default TermAndConditionsNewUsed6MonthWarrany;
